import { mount } from 'svelte';
import '../../etude-import/src/app.css';
import App from '../../etude-import/src/App.svelte';
import { setPays } from '../../etude-import/src/lib/i18n.svelte';

setPays('usa');
const target = document.getElementById('app');
const app = mount(App, { target: target!, props: { pays: 'usa' } });

// Retire le contenu SEO statique (index.html) une fois l'app montée : il n'existe que pour
// l'indexation, l'utilisateur voit la vraie SPA.
document.getElementById('seo-fallback')?.remove();

export default app;
